<template>
  <ion-page>
    <ion-header />
    <ion-content
      fullscreen="false"
      class="birthday"
      :id="id"
      :scroll-events="enableScrollEvent"
      @ionScroll="onScroll"
    >
      <main>
        <div class="w-full h-full min-h-screen bg-[#F0F2F4]">
          <Loading v-if="isLoading" />
          <template v-else>
            <Transition name="slide">
              <SideBar v-if="showSideBar" :is-main-page="true" />
            </Transition>
            <div :class="opaqueClass">
              <div
                v-if="$route.path !== '/birthdayboard/message'"
                ref="fixedHeader"
                class="fixed w-full z-10 board-safe-area"
                :style="{ backgroundColor: currBoard && currBoard.themeColour }"
              >
                <BoardHeader :show-board-change="true" />
                <FilterBar v-if="showFilterBar" />
              </div>
              <slot
                class="flex-1 page-bottom-padding"
                :class="{ '!pt-[92px]': isIos() }"
                test="test"
              >
              </slot>
            </div>
          </template>
        </div>
      </main>
    </ion-content>
  </ion-page>
</template>
<script>
import { IonPage, IonHeader, IonContent } from '@ionic/vue';
import { mapState } from 'vuex';
import Loading from '@/components/common/LoadingState';
import BoardHeader from '@/components/Board/Main/BoardHeader';
import SideBar from '@/components/Board/Main/SideBar';
import FilterBar from '@/components/Board/Filter/FilterBar';
import { isIosNativeOnly } from '@/utils/platform-check';
import { lockToPortrait } from '@/utils/screen-orientation';

export default {
  components: {
    IonPage,
    IonHeader,
    IonContent,
    Loading,
    BoardHeader,
    SideBar,
    FilterBar,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headerObserver: null,
    };
  },
  computed: {
    ...mapState('board', ['isLoading', 'currBoard', 'showSideBar', 'isYearSelected']),
    opaqueClass() {
      return this.showSideBar ? 'brightness-50 bg-[#F0F2F4] h-[100vh]' : '';
    },
    sideBarActive() {
      return this.showSideBar ? 'no-scroll' : '';
    },
    showFilterBar() {
      // Don't show when we are writing message
      if (this.$route.path === '/birthdayboard/message') return false;
      // if path is main page, we return base on whether is Year selected or not
      if (this.$route.path === '/birthdayboard') return this.isYearSelected;
      // else always return true
      return true;
    },
  },
  async mounted() {
    this.$nextTick(() => {
      if (this.$refs.fixedHeader) {
        this.updateHeaderHeight();
        this.headerObserver = new ResizeObserver(this.updateHeaderHeight);
        this.headerObserver.observe(this.$refs.fixedHeader);
      }
    });
    await lockToPortrait();
    await this.$store.dispatch('board/fetchBoardThemes');
    let cookieBoard = '';
    if (this.$cookies.get('cookieBoard') === undefined) {
      cookieBoard = null;
    } else {
      cookieBoard = this.$cookies.get('cookieBoard');
    }
    const query = this.$route;
    const regex = /\?(.+)/;
    const match = query.fullPath.match(regex);
    if (match) {
      const queryParameter = match[1];
      if (queryParameter === 'spl') {
        await this.fetchBoard(1);
      }
      if (queryParameter === 'spg') {
        await this.fetchBoard(2);
      }
      if (queryParameter === 'sph') {
        await this.fetchBoard(3);
      }
      if (queryParameter === 'spc') {
        await this.fetchBoard(4);
      }
      if (queryParameter === 'splyn') {
        await this.fetchBoard(5);
      }
    } else {
      await this.$store.dispatch('board/fetchBoards', { cookieBoard });
      await this.$store.dispatch(
        'board/fetchIsCurrBoardAdmin',
        this.currBoard ? this.currBoard.id : 0,
      );
    }
  },
  async beforeUnmount() {
    this.headerObserver?.disconnect();
    await lockToPortrait();
  },
  async created() {
    await Promise.all([this.$store.dispatch('lookups/fetchZoneCgMapping')]);
  },
  methods: {
    updateHeaderHeight() {
      const h = this.$refs.fixedHeader?.offsetHeight ?? 152;
      document.documentElement.style.setProperty('--board-fixed-height', `${h}px`);
    },
    isIos() {
      return isIosNativeOnly();
    },
    async fetchBoard(queryBoardId) {
      await this.$store.dispatch('board/fetchBoards', { queryBoardId });
      await this.$store.dispatch('board/fetchIsCurrBoardAdmin', queryBoardId);
      this.$router.replace({ fullPath: this.$route.path });
    },
    onScroll(event) {
      this.$emit('on-scroll', event);
    },
  },
};
</script>
<style scoped>
.birthday::part(scroll) {
  padding-bottom: var(--ion-safe-area-bottom, 0);
}
.board-safe-area {
  padding-top: env(safe-area-inset-top);
}
.no-scroll {
  overflow: hidden;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}
</style>
